// extracted by mini-css-extract-plugin
export default {"close_button":"menu_close_button__3j3N9","menu":"menu_menu__nfOvz","responsive_menu":"menu_responsive_menu__CaQDY","fade":"menu_fade__u2KBn"};